const React = require('react');

const LegalPageLayout = require('layouts/LegalPageLayout');
const PrivacyPolicyContents = require('components/PrivacyPolicyContents');
const { default: Classes } = require('./styles.scss');

module.exports = class PrivacyPolicy extends React.PureComponent {

    render() {

        return (
            <LegalPageLayout>
                <PrivacyPolicyContents className={Classes.legalContents} />
            </LegalPageLayout>
        );
    }
};
